<div class="thread__container flex">
  <sbnb-collapsible-drawer *ngIf="(isMobile$ | async) === false" [alwaysExpanded]="true" [beta]="true">
    <sbnb-back-button class="pt-4 pl-6"></sbnb-back-button>

    <ng-container
      *ngTemplateOutlet="
        reservationSection;
        context: { reservations: reservations, activeReservation: activeReservation }
      "></ng-container>

    <ng-container *ngTemplateOutlet="notesSection; context: { thread: thread }"></ng-container>

    <div *ngIf="reservations?.length > 0" class="sidebar__datepicker">
      <sbnb-date-picker
        [numMonths]="1"
        [showDurationLabels]="false"
        [preventSelection]="false"
        [startDate]="activeReservation.start_date"
        [reservations]="miniCalendarEvents"
        (dateClicked)="dateClicked($event, activeReservation?.listing?.property_id)"></sbnb-date-picker>
    </div>

    <ng-container *ngTemplateOutlet="tasksAndActivityAndDebug"></ng-container>
  </sbnb-collapsible-drawer>
  <main
    class="subnav__exists flex flex-col flex-1 !pb-0 !mb-0"
    [ngClass.lt-md]="{ mobile: true, subnav__exists: false }"
    #main
    id="main">
    <div *ngIf="guestLoading" class="guest__skeleton flex items-center justify-center">
      <mat-spinner *ngIf="loading" diameter="16"></mat-spinner>
    </div>

    <div class="thread__guest-container">
      <sbnb-guest-banner-thread
        *ngIf="thread"
        [thread]="thread"
        [canChangeEmail]="thread.supports?.email_change === true"
        (translationChange)="getMessages()"
        (guestNameUpdated)="onGuestNameUpdated($event)"></sbnb-guest-banner-thread>
      <ng-container *ngIf="isMobile$ | async">
        <div class="thread__guest-container__actions">
          <sbnb-button size="mini" type="secondary" icon="calendar" (click)="reservationDrawer.toggleDrawer()">
            Reservation
          </sbnb-button>

          <sbnb-button size="mini" type="secondary" (click)="detailsDrawer.toggleDrawer()">Guest & Details</sbnb-button>
        </div>
        <sbnb-collapsible-drawer #reservationDrawer [beta]="true">
          <ng-container
            *ngTemplateOutlet="
              reservationSection;
              context: { reservations: reservations, activeReservation: activeReservation }
            "></ng-container>

          <ng-container *ngTemplateOutlet="notesSection; context: { thread: thread }"></ng-container>

          <div *ngIf="reservations?.length > 0" class="sidebar__datepicker">
            <sbnb-date-picker
              [numMonths]="1"
              [showDurationLabels]="false"
              [preventSelection]="false"
              [startDate]="activeReservation.start_date"
              [reservations]="miniCalendarEvents"
              (dateClicked)="dateClicked($event, activeReservation?.listing?.property_id)"></sbnb-date-picker>
          </div>

          <ng-container *ngTemplateOutlet="tasksAndActivityAndDebug"></ng-container>
        </sbnb-collapsible-drawer>
        <sbnb-collapsible-drawer #detailsDrawer [beta]="true">
          <sbnb-reservation-details></sbnb-reservation-details>
        </sbnb-collapsible-drawer>
      </ng-container>
    </div>

    <sbnb-loading-spinner *ngIf="loading" class="h-full min-h-full"></sbnb-loading-spinner>

    <!-- Messages: Guest insights, then messages in descending order, then "page level" alerts -->
    <div #messagesContainer class="overflow-y-scroll px-2 md:px-10 h-full" *ngIf="messages?.length > 0">
      @if (shouldShowGuestInsights()) {
        <sbnb-insights
          [thread]="thread"
          [activeReservation]="activeReservation"
          [removeBorders]="window.innerWidth < 959"
          *ngIf="!loading && thread"></sbnb-insights>
      }

      <sbnb-thread-messages
        [alwaysReverse]="true"
        [messages]="messages"
        [reservation]="activeReservation"
        [guestVettingData]="guestVettingData$ | async"
        [threadId]="id"
        [withNameLabels]="!!thread.has_additional_guests"
        (reservationNeedsUpdating)="reservationNeedsUpdating($event)"
        (resendMessage)="resendFailedMessage($event)"></sbnb-thread-messages>

      <sbnb-thread-page-level-messages
        [activeReservation]="activeReservation"
        [thread]="thread"
        [guestVettingData]="guestVettingData$ | async"></sbnb-thread-page-level-messages>

      <div class="p-5" *ngIf="thread.show_sentiment_alert && (sentimentAnalysisEnabled$ | async)">
        <sbnb-issue-detected
          [label]="thread.label"
          [threadId]="id"
          (threadUpdated)="activityFeed.getActivityItems()"></sbnb-issue-detected>
      </div>
    </div>
    <!-- New message container-->
    <div
      #newMessageContainer
      class="thread__newmessage-container top-4 z-[99] w-full scroll-mt-40 mt-5 lg:mt-6 bg-white order-last md:order-none">
      <!-- Presence indicators -->
      <div class="mb-4 flex flex-col gap-2">
        <!-- AI presence -->
        <div *ngIf="autoReplyWorking" class="gap-2 flex items-center" data-attr="presence-indicator">
          <div class="logo__palantir w-5 h-5 flex items-center justify-center">
            <img width="20px" height="20px" src="/assets/images/palantir.svg" alt="Hospitable logo" />
          </div>
          <div class="flex items-baseline gap-2 bg-smoke-lighter rounded-lg px-2 py-1">
            <div class="text-xs">{{ autoReplyWorkingMessage }}</div>

            <div class="flex items-center gap-1">
              <div class="h-1 w-1 rounded-full bg-night animate-bounce-short"></div>
              <div class="h-1 w-1 rounded-full bg-night animate-bounce-delay-1"></div>
              <div class="h-1 w-1 rounded-full bg-night animate-bounce-delay-2"></div>
            </div>
          </div>
        </div>

        <!-- User presence -->
        <div
          class="flex flex-col gap-2"
          *ngIf="usersViewing.length > 0 || usersTyping.length > 0"
          data-element="thread-presence-indicators">
          <!-- Show users viewing the thread -->
          <div class="flex items-center gap-2" *ngIf="usersViewing.length > 0" data-element="thread-viewing-users">
            <div class="flex items-center gap-2">
              <app-active-user-avatar *ngFor="let user of usersViewing" [user]="user"></app-active-user-avatar>
              <span class="text-xs text-night">
                {{
                  usersViewing.length === 1
                    ? usersViewing[0].first_name + ' is'
                    : usersViewing.length === 2
                      ? usersViewing[0].first_name + ' and ' + usersViewing[1].first_name + ' are'
                      : 'Multiple people are'
                }}
                viewing this conversation
              </span>
            </div>
          </div>

          <!-- Show typing indicator -->
          <app-typing-indicator
            *ngIf="usersTyping.length > 0"
            [users]="usersTyping"
            data-element="thread-typing-indicator"></app-typing-indicator>
        </div>
      </div>

      <div
        *ngIf="thread"
        class="thread__newmessage-input p-2.5 mb-5 w-full flex flex-col gap-3 lt:gap-1.5"
        [class.pointer-events-none]="
          thread.platform === Channel.Booking && thread.supports.bdc_rtb_messaging === false
        ">
        <div class="animate-height flex-auto flex flex-col gap-2 items-start place-content-start">
          <div class="w-full flex">
            <button
              *ngIf="thread?.hosts?.length > 1"
              class="multiple-users flex items-center gap-1"
              [matMenuTriggerFor]="usersMenu"
              [matTooltip]="'Message will be sent from ' + thread.host.name">
              <img
                *ngIf="thread?.host"
                class="size-8 min-w-8 rounded-full relative"
                [src]="thread.host.image"
                onerror="this.src='/assets/images/profile-default.png'"
                matTooltipPosition="below" />

              <svg class="size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6 9L12 15L18 9"
                  stroke="#5C576A"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>

              <mat-menu #usersMenu>
                <button mat-menu-item *ngFor="let host of thread.hosts" (click)="thread.host = host">
                  <div class="flex items-center gap-3">
                    <img class="size-6 rounded-full" [src]="host.image" />
                    <span>{{ host.name }}</span>
                  </div>
                </button>
              </mat-menu>
            </button>

            <textarea
              sbnbResizeObserver
              (resized)="onMessageResize($event)"
              *ngIf="tributeOptions && { canUploadImages: canUploadImages$ | async } as context"
              #newMessageTextarea
              appPasteHandler
              cdkTextareaAutosize
              matInput
              class="ml-1.5 p-0 leading-normal w-full border-0 bg-transparent transition-[height] duration-200 ease-out"
              [class.ai-prewritten]="(combinedAIMessage$ | async)?.is_prewritten"
              [(ngModel)]="newMessageContents"
              [placeholder]="
                thread.platform === Channel.Booking && thread.supports.bdc_rtb_messaging === false
                  ? 'Booking.com does not allow messaging for inquiries. Please use the pre-approve/deny buttons.'
                  : (isMobile$ | async)
                    ? 'Write a message...'
                    : 'Write a message or type \'/\'...'
              "
              [tribute]="tributeOptions"
              [cdkAutosizeMaxRows]="(isMobile$ | async) === true ? 8 : 16"
              [disabled]="
                messageSending ||
                (generateReplyLoadingState$ | async) === LoadingState.Pending ||
                (generateImprovementLoadingState$ | async) === LoadingState.Pending
              "
              (mentionItemSelected)="applyCannedResponse($event)"
              (imagePasted)="context.canUploadImages ? onImagePasted($event) : null"
              (keyup)="clearUndoMessage()"
              (input)="onMessageInput()"></textarea>
          </div>

          <div *ngIf="imageUploads?.length > 0" class="h-[52px] mt-auto">
            <div fxLayout>
              <div class="relative mr-3" *ngFor="let image of imageUploads | slice: 0 : 5; let i = index">
                <img [src]="image.src" class="size-12" />
                <button class="absolute -right-1 -top-1 rounded-full w-5 p-0.5 bg-white" (click)="removeImage(index)">
                  <sbnb-icon [size]="16" class="block" icon="delete"></sbnb-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- AI-related pills -->
        <div class="flex items-center justify-end" *ngIf="!messageSending">
          <div *ngIf="combinedAIMessage$ | async as generatedReplyValue">
            <a
              [routerLink]="[
                activeReservation?.listing?.property_id
                  ? '/properties/property/' + activeReservation.listing.property_id + '/knowledge'
                  : '/properties'
              ]"
              *ngIf="generatedReplyValue.knowledge_hub_fetched"
              class="bg-grass-lighter border border-grass text-grass-darker text-xs px-2 py-0.5 rounded-md">
              Knowledge Hub used &check;
            </a>
            <a
              [routerLink]="[
                activeReservation?.listing?.property_id
                  ? '/properties/property/' + activeReservation.listing.property_id + '/knowledge'
                  : '/properties'
              ]"
              *ngIf="generatedReplyValue && !generatedReplyValue.using_knowledge_hub"
              class="bg-raspberry-lighter border border-raspberry text-raspberry-darker text-xs px-2 py-0.5 rounded-md gap-1 flex items-center">
              <span>Knowledge Hub not configured</span>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-4">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                </svg>
              </span>
            </a>
          </div>
        </div>
        <!-- End AI-related pills -->

        <div
          [style.margin-top]="forceNewMessageEditorExpanded ? '24px' : '0px'"
          class="flex flex-col sm:flex-row justify-between items-end sm:items-center gap-4 sm:gap-2 mt-2"
          *ngIf="!(thread.platform === Channel.Booking && thread.supports.bdc_rtb_messaging === false)">
          <!-- AI thumbs up/down -->
          <!-- placeholder to push the rest of the content to the side when buttons are hidden -->
          <div *ngIf="!generatedReplyMessage || undoMessage"></div>

          <div *ngIf="generatedReplyMessage && !undoMessage" class="flex items-center gap-3 my-2 rate-ai-suggestion">
            <div class="text-sm text-gray-400">
              <span>Rate the AI:</span>
            </div>

            <div
              class="text-gray-300 transition h-5 w-5"
              [class.text-green-500]="sentAIFeedback === 'like'"
              [class.cursor-pointer]="sentAIFeedback === null"
              [class.hover:text-green-500]="sentAIFeedback === null"
              (click)="onAISuggestionLiked()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.958 8.958 0 0 0-1.302 4.665c0 1.194.232 2.333.654 3.375Z" />
              </svg>
            </div>

            <div
              class="text-gray-300 cursor-pointer transition h-5 w-5"
              [class.text-red-500]="sentAIFeedback === 'dislike'"
              [class.cursor-pointer]="sentAIFeedback === null"
              [class.hover:text-red-500]="sentAIFeedback === null"
              (click)="onAISuggestionDisliked()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M7.498 15.25H4.372c-1.026 0-1.945-.694-2.054-1.715a12.137 12.137 0 0 1-.068-1.285c0-2.848.992-5.464 2.649-7.521C5.287 4.247 5.886 4 6.504 4h4.016a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23h1.294M7.498 15.25c.618 0 .991.724.725 1.282A7.471 7.471 0 0 0 7.5 19.75 2.25 2.25 0 0 0 9.75 22a.75.75 0 0 0 .75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 0 0 2.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384m-10.253 1.5H9.7m8.075-9.75c.01.05.027.1.05.148.593 1.2.925 2.55.925 3.977 0 1.487-.36 2.89-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398-.306.774-1.086 1.227-1.918 1.227h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 0 0 .303-.54" />
              </svg>
            </div>
          </div>
          <!-- End AI thumbs up/down -->

          <div class="flex items-center gap-2">
            <!-- Image upload icon-->
            <div
              *ngIf="(canUploadImages$ | async) === true"
              class="newmessage-icon-button"
              (click)="imageInput.click()"
              matTooltip="Attach images">
              <mat-icon>attach_file</mat-icon>
              <mat-spinner *ngIf="imageLoading" [diameter]="16"></mat-spinner>
              <input
                id="file"
                [style.opacity]="0"
                class="image__input"
                #imageInput
                type="file"
                multiple="multiple"
                accept="image/jpeg, image/jpg, image/png"
                style="display: none"
                (change)="onImageInputChange(imageInput)" />
            </div>

            <!-- Canned responses icon-->
            <button
              class="newmessage-icon-button"
              [matTooltip]="(isMobile$ | async) ? null : 'Send a Canned response'"
              [matMenuTriggerFor]="cannedResponsesMenu"
              (menuOpened)="menuOpen = true; focusCannedResponsesSearch()"
              (menuClosed)="menuOpen = false">
              <img style="width: 60px; height: 22px" src="/assets/iconography/language.svg" onload="SVGInject(this)" />

              <mat-menu
                #cannedResponsesMenu="matMenu"
                class="filters__cdk-menu-480"
                yPosition="below"
                xPosition="before">
                <input
                  #searchInput
                  *ngIf="cannedResponseOptions && cannedResponseOptions.length >= numListOptionsForSearchBar"
                  class="filters__input-list-search"
                  [(ngModel)]="searchCriteria"
                  type="text"
                  placeholder="Search"
                  (click)="$event.stopPropagation()"
                  (blur)="searchInput.focus()" />

                <div
                  class="filter__list-fixed-height"
                  *ngIf="cannedResponseOptions && cannedResponseOptions.length > 0">
                  <ng-container *ngFor="let cr of cannedResponseOptions">
                    <button
                      *ngIf="filtersMatchSearchCriteria(cr, searchCriteria)"
                      style="height: auto !important"
                      mat-menu-item
                      (click)="applyCannedResponse(cr); clearUndoMessage()">
                      <div fxLayout="column">
                        <strong>{{ cr.name }}</strong>
                        <span class="ellipsis" style="position: relative; top: -5px">{{ cr.rule_preview }}</span>
                      </div>
                    </button>
                  </ng-container>
                </div>

                <div
                  *ngIf="cannedResponseOptions && cannedResponseOptions.length === 0"
                  class="properties__no-listings text__small">
                  You don't have any Canned responses that match this conversation scope.
                </div>
              </mat-menu>
            </button>

            <!-- AI improvements -->
            <!-- Undo button after improvment suggestion -->
            <sbnb-button
              *ngIf="undoMessage"
              class="ai-undo-button"
              size="mini"
              type="secondary"
              (clicked)="undoImprovement()"
              icon="undo">
              Undo
            </sbnb-button>
            <!-- Improve or suggest button -->
            <div *ngIf="thread.uuid && !undoMessage && thread.guest?.guest_id?.trim()?.length > 0" id="chatgpt-button">
              <sbnb-chatgpt-generate-button
                *ngIf="!aiSuggested || showImproveButton"
                [mode]="newMessageContents?.trim()?.length > 0 ? 'improve' : 'suggest'"
                [loadingState]="
                  (generateReplyLoadingState$ | async) === LoadingState.Pending ||
                  (generateImprovementLoadingState$ | async) === LoadingState.Pending
                "
                (buttonClicked)="
                  onAIGenerateResponseClicked(thread.uuid, thread.host?.user_id, $event, newMessageContents)
                "></sbnb-chatgpt-generate-button>
              <sbnb-button
                *ngIf="
                  !showImproveButton &&
                  aiSuggested &&
                  (generateReplyLoadingState$ | async) !== LoadingState.Pending &&
                  newMessageContents?.length > 0
                "
                size="mini"
                type="secondary"
                icon="delete"
                (clicked)="clearGeneratedMessage()">
                Clear
              </sbnb-button>
            </div>

            <sbnb-button
              *ngIf="newMessageContents?.length || imageUploads?.length > 0"
              class="send-button"
              size="mini"
              icon="send"
              [loading]="messageSending"
              [disabled]="
                messageSending ||
                (imageUploads?.length > 0 &&
                  !newMessageContents?.length &&
                  (thread.platform === 'manual' || thread.platform === 'direct'))
              "
              (click)="sendMessage(); clearUndoMessage()">
              Send
            </sbnb-button>
          </div>
        </div>
      </div>
    </div>
  </main>
  <sbnb-collapsible-drawer *ngIf="(isMobile$ | async) === false" [beta]="true">
    <div class="py-4 pr-4 pb-20"><sbnb-reservation-details></sbnb-reservation-details></div>
  </sbnb-collapsible-drawer>
</div>

<sbnb-fullscreen-upload-dropzone
  *ngIf="canUploadImages$ | async"
  (filesDropped)="onDroppedFile($event)"></sbnb-fullscreen-upload-dropzone>

<!-- NOTE SECTION TEMPLATE -->
<ng-template #notesSection let-thread="thread">
  <div *ngIf="thread?.hasOwnProperty('note')" class="sidebar__section">
    <sbnb-thread-notes [uuid]="thread.uuid" [note]="thread.note" (noteSaved)="thread.note = $event"></sbnb-thread-notes>
  </div>
</ng-template>

<!-- RESERVATION SECTION -->
<ng-template #reservationSection let-reservations="reservations" let-activeReservation="activeReservation">
  <div *ngIf="reservations && reservations.length > 0" class="sidebar__section overflow-x-hidden">
    <div class="reservation__holder flex items-center justify-between">
      <div class="flex items-center gap-2">
        <sbnb-mini-listing-img
          [imgSrc]="activeReservation.listing.image"
          [imgAlt]="activeReservation.listing.name"></sbnb-mini-listing-img>
        <strong>Reservation</strong>
      </div>
      <sbnb-prev-next
        *ngIf="reservations.length > 1"
        class="relative left-5"
        [count]="reservations.length"
        (activeIndexChange)="changeActiveReservation($event)"></sbnb-prev-next>
    </div>
    <sbnb-reservation-card
      [activeReservation]="activeReservation"
      [thread]="thread"
      [showDetailsButton]="false"
      (reservationNeedsUpdating)="reservationNeedsUpdating($event)"></sbnb-reservation-card>

    <!-- We're just showing this new sidebar experience for GP Tasks for Direct premium for now -->
    @if (activeReservation.payment_provider === 'adyen') {
      <div class="-mx-6 block mt-6 border-t border-smoke p-6 pb-0 space-y-4 *:block">
        <sbnb-guest-portal-tasks
          [reservation]="activeReservation"
          [propertyId]="activeReservation.listing.property_id"></sbnb-guest-portal-tasks>

        <!-- Security deposit -->
        <sbnb-security-deposit-sidebar
          *ngIf="thread.platform === Channel.Direct"
          [reservation]="activeReservation"></sbnb-security-deposit-sidebar>

        <!-- Upsells -->
        <sbnb-upsells-status
          *ngIf="activeReservation.supports.upsells"
          [reservation]="activeReservation"></sbnb-upsells-status>
      </div>
    } @else {
      <div class="-mx-6 block mt-6 border-t border-smoke p-6 pb-0 space-y-4 *:block">
        <!-- Copy guest portal link-->
        <sbnb-guest-portal-sidebar-link [reservationUuid]="activeReservation.uuid"></sbnb-guest-portal-sidebar-link>

        <!-- Security deposit -->
        <sbnb-security-deposit-sidebar
          *ngIf="thread.platform === Channel.Direct"
          [reservation]="activeReservation"></sbnb-security-deposit-sidebar>

        <!-- Guest vetting -->
        <sbnb-guest-vetting-status *ngIf="activeReservation.autohost"></sbnb-guest-vetting-status>

        <!-- Rental agreements-->
        <sbnb-rental-agreements-sidebar-list
          *ngIf="
            (userPermissionsService.hasAccessTo(Features.PERM_INBOX) | async) === true &&
            (userPermissionsService.hasAccessTo(Features.PERM_RESERVATION_FINANCIALS) | async) === true
          "
          [canAddAgreement]="(userPermissionsService.hasAccessTo(Features.PERM_MANAGE_RESERVATIONS) | async) === true"
          [reservationUuid]="activeReservation.uuid"
          [reservation]="activeReservation"
          [propertyId]="activeReservation.listing.property_id"></sbnb-rental-agreements-sidebar-list>

        <!-- Upsells -->
        <sbnb-upsells-status
          *ngIf="activeReservation.supports.upsells"
          [reservation]="activeReservation"></sbnb-upsells-status>
      </div>
    }
  </div>
</ng-template>

<ng-template #tasksAndActivityAndDebug>
  <div class="sidebar__section" *ngIf="activeReservation">
    <sbnb-thread-smartlock-codes [reservationUuid]="activeReservation.uuid"></sbnb-thread-smartlock-codes>
  </div>

  <div class="sidebar__section" *ngIf="activeReservation">
    <sbnb-thread-thermostat-schedules [reservationUuid]="activeReservation.uuid"></sbnb-thread-thermostat-schedules>
  </div>

  <div class="sidebar__section">
    <sbnb-activity-feed #activityFeed [threadUuid]="id" [openInboxReviewModal]="true"></sbnb-activity-feed>
  </div>

  <div class="sidebar__section">
    <sbnb-task-list [lite]="true" [threadUuid]="id" [reservation]="activeReservation"></sbnb-task-list>
  </div>

  <div *ngIf="isCS && thread && (debugMode$ | async)" class="sidebar__section">
    <h4>Debug info:</h4>
    <sbnb-cs-debug-item
      *ngIf="thread.status_key !== 'inquiry'"
      label="code"
      [coreNovaLink]="'/external/reservations/thread/' + thread.thread_id"
      linkLabel="Nova"
      [value]="thread.reservation_code"></sbnb-cs-debug-item>
    <sbnb-cs-debug-item
      label="thread_id"
      [value]="thread.thread_id"
      [coreNovaLink]="'/external/conversations/thread/' + thread.thread_id"
      linkLabel="Nova"></sbnb-cs-debug-item>
    <sbnb-cs-debug-item label="guest_id" [value]="thread.guest?.guest_id"></sbnb-cs-debug-item>
    <sbnb-cs-debug-item label="user_id" [value]="thread.host?.user_id"></sbnb-cs-debug-item>
  </div>
</ng-template>
<!-- END RESERVATION SECTION -->
